import { render, staticRenderFns } from "./DeviceInformationSingleGlobal.vue?vue&type=template&id=0328919a"
import script from "./DeviceInformationSingleGlobal.vue?vue&type=script&lang=js"
export * from "./DeviceInformationSingleGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports